if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function (cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = (format || this.money_format);
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';
            return dollars + cents;
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
        return formatString.replace(placeholderRegex, value);
    };
}
Shopify.optionsMap = {};
Shopify.updateOptionsInSelector = function (selectorIndex) {
    switch (selectorIndex) {
        case 0:
            var key = 'root';
            var selector = jQuery('.single-option-selector:eq(0)');
            break;
        case 1:
            var key = jQuery('.single-option-selector:eq(0)').val();
            var selector = jQuery('.single-option-selector:eq(1)');
            break;
        case 2:
            var key = jQuery('.single-option-selector:eq(0)').val();
            key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
            var selector = jQuery('.single-option-selector:eq(2)');
    }

    var initialValue = selector.val();
    selector.empty();
    var availableOptions = Shopify.optionsMap[key];
    for (var i = 0; i < availableOptions.length; i++) {
        var option = availableOptions[i];
        var newOption = jQuery('<option></option>').val(option).html(option);
        selector.append(newOption);
    }
    jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
        if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
        }
        else {
            $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
        }
    });
    if (jQuery.inArray(initialValue, availableOptions) !== -1) {
        selector.val(initialValue);
    }
    selector.trigger('change');
};
Shopify.linkOptionSelectors = function (product) {
    // Building our mapping object.
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    jQuery(".single-option-selector:eq(0)").change(function () {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
    // When there is an update in the second dropdown.
    jQuery(".single-option-selector:eq(1)").change(function () {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true;
    });
};
window.vela = window.vela || {};
vela.cacheSelectors = function () {
    vela.cache = {
        $html: $('html'),
        $body: $('body'),
        $recoverPasswordLink: $('#RecoverPassword'),
        $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
        $recoverPasswordForm: $('#RecoverPasswordForm'),
        $customerLoginForm: $('#CustomerLoginForm'),
        $passwordResetSuccess: $('#ResetSuccess'),
        $velaProductImage: $('#ProductPhotoImg'),
        $velaNewletterModal: $('#velaNewsletterModal')
    };
};
vela.init = function () {
    FastClick.attach(document.body);
    vela.cacheSelectors();
    vela.startTheme();
    vela.responsiveVideos();
    vela.loginForms();
    vela.productThumbImage();
    vela.goToTop();
    vela.slickCarousel();
    vela.owlOneCarousel();
    vela.velaConfigSection();
    vela.menuMobile();
    vela.dismissFlashBanner();
};

vela.drawersInit = function () {
    //vela.LeftDrawer = new vela.Drawers('menuDrawer', 'Left', false);
    vela.RightDrawer = new vela.Drawers('cartDrawer', 'Right', true, {
    	
  	});
};

vela.getHash = function () {
    return window.location.hash;
};

vela.startTheme = function () {
    $(".swatch :radio").change(function () {
        var t = $(this).closest(".swatch").attr("data-option-index");
        var n = $(this).val();
        $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
};

vela.productPage = function (options) {
    var moneyFormat = options.money_format,
        variant = options.variant,
        selector = options.selector;
    var $addToCart = $('#AddToCart'),
        $productPrice = $('#ProductPrice'),
        $comparePrice = $('#ComparePrice'),
        $quantityElements = $('.qtySelector, label + .velaJsQty'),
        $formulaWeight = $('.formula-weight')
        $formulaCpg = $('.formula-cpg')
        $addToCartText = $('#AddToCartText');
    if (variant) {
        $(document).trigger("toogleVariant", {'variant':variant, 'options':selector.product.options});
        $('[name=product_id]').val(variant.id);
        if (variant.available) {
            $addToCart.removeClass('disabled').prop('disabled', false);
            $addToCartText.html("Agregar al carrito");
            $quantityElements.show();
        } else {
            $addToCart.addClass('disabled').prop('disabled', true);
            $addToCartText.html("Agotado");
            $quantityElements.hide();
        }
        
        if (variant.compare_at_price > variant.price) {
            $comparePrice
                .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
                .show();
        } else {
            $comparePrice.hide();
        }
        var form = $('#' + selector.domIdPrefix).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
            if (radioButton.size()) {
                radioButton.get(0).checked = true;
            }
        }

        if(variant.title!="Default Title"){
            $('.gl-t-variant-title').text(variant.title);
        }
        if (variant.available) {
            $('.productAvailability').removeClass('outstock');
            $('.productAvailability').addClass('instock');
            $('.productAvailability').html('<label>' + "Disponibilidad" + '</label>: ' + "En stock\n");
        } else {
            $('.productAvailability').removeClass('instock');
            $('.productAvailability').addClass('outstock');
            $('.productAvailability').html('<label>' + "Disponibilidad" + '</label>: ' + "Sin stock");
        }
  	} else {
        $addToCart.addClass('disabled').prop('disabled', true);
        $addToCartText.html("Sin stock");
        $quantityElements.hide();
  	}
    if (variant && variant.featured_image) {
        var originalImage = $(".proFeaturedImage img");
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
            $('#productThumbs img').each(function () {
                var parentThumbImg = $(this).parent();
                var idProductImage = $(this).parent().data("imageid");
                if (idProductImage == newImage.id) {
                    $(this).parent().trigger('click');
                    return false;
                }
            });
        });
    }
};
vela.responsiveVideos = function () {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
    $iframeVideo.each(function () {
        $(this).wrap('<div class="videoContainer"></div>');
    });
    $iframeReset.each(function () {
        this.src = this.src;
    });
};

vela.goToTop = function () {
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 200) {
            $('#goToTop').fadeIn();
        } else {
            $('#goToTop').fadeOut();
        }
    });
    $("#goToTop").click(function () {
        $("body,html").animate({ scrollTop: 0 }, "normal");
        $("#pageContainer").animate({ scrollTop: 0 }, "normal");
        return !1
    });
}

vela.loginForms = function () {
    function showRecoverPasswordForm() {
        vela.cache.$recoverPasswordForm.show();
        vela.cache.$customerLoginForm.hide();
    }
    function hideRecoverPasswordForm() {
        vela.cache.$recoverPasswordForm.hide();
        vela.cache.$customerLoginForm.show();
    }
    vela.cache.$recoverPasswordLink.on('click', function (evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
    });
    vela.cache.$hideRecoverPasswordLink.on('click', function (evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
    });
    if (vela.getHash() == '#recover') {
        showRecoverPasswordForm();
    }
};

vela.resetPasswordSuccess = function () {
    vela.cache.$passwordResetSuccess.show();
};

vela.productImage = function () {
    if (vela.cache.$velaProductImage.length > 0) {
        if (($(window).width()) >= 992) {
            //DESKTOP
            vela.cache.$velaProductImage.elevateZoom({
                zoomEnabled: false,
                gallery: 'productThumbs',
                cursor: 'pointer',
                galleryActiveClass: 'active',
                imageCrossfade: true,
                scrollZoom: true,
                onImageSwapComplete: function () {
                    $(".zoomWrapper div").hide();
                },
                loadingIcon: false
            });
            vela.cache.$velaProductImage.bind("click", function (e) {
                var ez = vela.cache.$velaProductImage.data('elevateZoom');
                $.fancybox(ez.getGalleryList());
                return false;
            });
        }
        else if (($(window).width()) <= 991) {
            //TABLET, MOBILE
            vela.cache.$velaProductImage.elevateZoom({
                zoomEnabled: false,
                gallery: 'productThumbs',
                cursor: 'pointer',
                galleryActiveClass: 'active',
                imageCrossfade: false,
                scrollZoom: false,
                onImageSwapComplete: function () {
                    $(".zoomWrapper div").hide();
                },
                loadingIcon: false
            });
            vela.cache.$velaProductImage.bind("click", function (e) {
                return false;
            });
        }
    }
};

vela.productThumbImage = function () {
    if ($("#productThumbs").length > 0) {
        $('#productThumbs .owl-carousel').owlCarousel({
            items: 4,
            nav: true,
            responsive: {
                0: {
                    items: 4,
                }
            }
        });
    }
};

vela.Drawers = (function () {
    var Drawer = function (id, position, iscart, options) {
        var defaults = {
            close: '.jsDrawerClose',
            open: '.jsDrawerOpen' + position,
            openClass: 'jsDrawerOpen',
            dirOpenClass: 'jsDrawerOpen' + position
        };
        this.$nodes = {
            parent: $('body, html'),
            page: $('#pageContainer'),
            moved: $('.isMoved')
        };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.iscart = iscart;
        this.$drawer = $('#' + id);
        if (!this.$drawer.length) {
            return false;
        }
        this.drawerIsOpen = false;
        this.init();
    };
    Drawer.prototype.init = function () {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
    };
    Drawer.prototype.open = function (evt) {
        if (window.ajaxcart_type == 'modal' && this.iscart) {
            var externalCall = false;
            this.$drawer.modal();//Use modal Bootstrap
            if (evt) {
                evt.preventDefault();

            } else {
                externalCall = true;
            }
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                this.$activeSource = $(evt.currentTarget);
            }
            if (this.config.onDrawerOpen && typeof (this.config.onDrawerOpen) == 'function') {
                if (!externalCall) {
                    this.config.onDrawerOpen();
                }
            }
        } else if (window.ajaxcart_type == 'drawer') {
            var externalCall = false;
            if (evt) {
                evt.preventDefault();
            } else {
                externalCall = true;
            }
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                this.$activeSource = $(evt.currentTarget);
            }
            if (this.drawerIsOpen && !externalCall) {
                return this.close();
            }
            this.$nodes.moved.addClass('is-transitioning');
            this.$drawer.prepareTransition();
            this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
            this.drawerIsOpen = true;
            this.trapFocus(this.$drawer, 'drawer_focus');
            if (this.config.onDrawerOpen && typeof (this.config.onDrawerOpen) == 'function') {
                if (!externalCall) {
                    this.config.onDrawerOpen();
                }
            }
            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'true');
            }
            this.$nodes.page.on('touchmove.drawer', function () {
                return false;
            });
            this.$nodes.page.on('click.drawer', $.proxy(function () {
                this.close();
                return false;
            }, this));
        } else {
            var externalCall = false;
            if (evt) {
                evt.preventDefault();
            } else {
                externalCall = true;
            }
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                this.$activeSource = $(evt.currentTarget);
            }
            if (this.config.onDrawerOpen && typeof (this.config.onDrawerOpen) == 'function') {
                if (!externalCall) {
                    this.config.onDrawerOpen();
                }
            }
        }
    };
    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) { // don't close a closed drawer
            return;
        }
        $(document.activeElement).trigger('blur');
        this.$nodes.moved.prepareTransition({ disableExisting: true });
        this.$drawer.prepareTransition({ disableExisting: true });
        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
        this.drawerIsOpen = false;
        this.removeTrapFocus(this.$drawer, 'drawer_focus');
        this.$nodes.page.off('.drawer');
    };
    Drawer.prototype.trapFocus = function ($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $container.attr('tabindex', '-1');
        $container.focus();
        $(document).on(eventName, function (evt) {
            if ($container[0] !== evt.target && !$container.has(evt.target).length) {
                $container.focus();
            }
        });
    };
    Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $container.removeAttr('tabindex');
        $(document).off(eventName);
    };
    return Drawer;
})();
vela.loadingSite = function () {
    $('#loadingSite').fadeOut();
};

vela.menuMobile = function () {
    $('#btnMenuMobile').on("click", function (e) {
        e.preventDefault();
        $('body').toggleClass("menuMobileActive");
    });
    $('#openFilterDrawer').on("click", function (e) {
        e.preventDefault();
        $('body').toggleClass("jsDrawerOpen jsDrawerOpenRight");
    });
    $('#closeFilterMenu').on("click", function (e) {
        e.preventDefault();
        $('body').removeClass("jsDrawerOpen jsDrawerOpenRight");
    });

    $('.btnMenuClose').on("click", function (e) {
        e.preventDefault();
        $('body').removeClass("menuMobileActive");
    });
};

vela.slickCarousel = function () {
    $(".slickCarousel").each(function () {
        var slickCarousel = $(this);
        var columnfive = slickCarousel.data("columnfive")
        if (!columnfive) {
            columnfive = 2;
        }
        var columnOne = slickCarousel.data("columnone"),
            columnTwo = slickCarousel.data("columntwo"),
            columnThree = slickCarousel.data("columnthree"),
            columnFour = slickCarousel.data("columnfour"),
            onlyMobile = slickCarousel.data("onlymobile"),
            arrows = slickCarousel.data("arrows");

        if (($(window).width()) >= 768 && onlyMobile) {
            return false;
        }

        var config = {
            responsive: [
                {
                    breakpoint: 1200,
                    arrows: arrows,
                    settings: {
                        slidesToShow: columnTwo
                    }
                },
                {
                    breakpoint: 992,
                    arrows: arrows,
                    settings: {
                        slidesToShow: columnThree
                    }
                },
                {
                    breakpoint: 768,
                    arrows: arrows,
                    settings: {
                        slidesToShow: columnFour
                    }
                },
                {
                    breakpoint: 480,
                    arrows: arrows,
                    settings: {
                        slidesToShow: columnfive
                    }
                }
            ]
        };
        $(this).slick(config);
    });
};
vela.owlOneCarousel = function () {
    //tablet Up
    if (($(window).width()) >= 768) {
        $(".owlCarouselPlay .owl-carousel").each(function () {
            var owlCarousel = $(this);
            var nav = owlCarousel.data("nav"),
                autoplay = owlCarousel.data("autoplay"),
                autospeed = owlCarousel.data("autospeed"),
                pagination = owlCarousel.data("pagination"),
                speed = owlCarousel.data("speed"),
                columnOne = owlCarousel.data("columnone"),
                columnTwo = owlCarousel.data("columntwo"),
                columnThree = owlCarousel.data("columnthree"),
                columnFour = owlCarousel.data("columnfour"),
                columnFive = owlCarousel.data("columnfive");
            if (!columnFive) {
                columnFive = 1;
            }

            var config = {
                items: columnOne,
                itemsDesktop: [1199, columnTwo],
                itemsDesktopSmall: [991, columnThree],
                itemsTablet: [767, columnFour],
                itemsTabletSmall: [479, 1],
                itemsMobile: [0, 1],
                responsiveClass: true,
                responsive: {
                    0: {
                        items: columnFive
                    },
                    479: {
                        items: columnFour
                    },
                    767: {
                        items: columnFour
                    },
                    991: {
                        items: columnThree
                    },
                    1199: {
                        items: columnOne
                    }
                },
                nav: nav,
                dots: false,
                smartSpeed: speed,
                afterInit: RemoveLoading(owlCarousel)
            };
            if (pagination) {
                config.dots = true;
            }
            if (autoplay) {
                config.autoplay = autoplay;
                config.autoplaySpeed = autospeed;
            }
            owlCarousel.owlCarousel(config);

            function RemoveLoading(el) {
                el.parents('.proOwlCarousel').removeClass('proLoading');
            }
            function FirstLastActiveItem(el) {
                el.find(".owl-item").removeClass("first");
                el.find(".owl-item.active").first().addClass("first");
                el.find(".owl-item").removeClass("last");
                el.find(".owl-item.active").last().addClass("last");
            }
        });

    }

    if ($("body").hasClass('template-product') || $("body").is("#veet-products") || $("body").is("#choco-milk®")) {
        $("#format-related").each(function () {
            var owlCarousel = $(this);
            var nav = owlCarousel.data("nav"),
                autoplay = owlCarousel.data("autoplay"),
                autospeed = owlCarousel.data("autospeed"),
                pagination = owlCarousel.data("pagination"),
                speed = owlCarousel.data("speed"),
                columnOne = owlCarousel.data("columnone"),
                columnTwo = owlCarousel.data("columntwo"),
                columnThree = owlCarousel.data("columnthree"),
                columnFour = owlCarousel.data("columnfour"),
                columnFive = owlCarousel.data("columnfive");
            if (!columnFive) {
                columnFive = 1;
            }

            var config = {
                items: columnOne,
                itemsDesktop: [1199, columnTwo],
                itemsDesktopSmall: [991, columnThree],
                itemsTablet: [767, columnFour],
                itemsTabletSmall: [479, 1],
                itemsMobile: [0, 1],
                responsiveClass: true,
                responsive: {
                    0: {
                        items: columnFive
                    },
                    479: {
                        items: columnFour
                    },
                    767: {
                        items: columnFour
                    },
                    991: {
                        items: columnThree
                    },
                    1199: {
                        items: columnOne
                    }
                },
                nav: nav,
                dots: false,
                smartSpeed: speed,
                afterInit: RemoveLoading(owlCarousel)
            };
            if (pagination) {
                config.dots = true;
            }
            if (autoplay) {
                config.autoplay = autoplay;
                config.autoplaySpeed = autospeed;
            }
            owlCarousel.owlCarousel(config);

            function RemoveLoading(el) {
                el.parents('.proOwlCarousel').removeClass('proLoading');
            }
            function FirstLastActiveItem(el) {
                el.find(".owl-item").removeClass("first");
                el.find(".owl-item.active").first().addClass("first");
                el.find(".owl-item").removeClass("last");
                el.find(".owl-item.active").last().addClass("last");
            }
        });
    }
};

vela.velaConfigSection = function () {
    var element = $('#shopify-section-vela-header');
    if (element[0].attributes.length == 3) {
        $('#velaConfigSection').addClass('showBox');
    }
    else {
        $('#velaConfigSection').empty();
    }
    $('.menuSsWrap .btnConfigSection').on('click', function () {
        $('.menuSsWrap').addClass('active');
    });
    $('.menuSsWrap .closeMenu').on('click', function () {
        $('.menuSsWrap').removeClass('active');
    });
};

/* ================ SHOPIFY DEBUT - VELA CUSTOMIZE ================ */
window.velatheme = window.velatheme || {};
velatheme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
velatheme.Sections.prototype = _.assignIn({}, velatheme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), {
            id: id,
            type: type,
            container: container
        });
        this.instances.push(instance);
    },
    _onSectionLoad: function (evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function (evt) {
        this.instances = _.filter(this.instances, function (instance) {
            var isEventInstance = (instance.id === evt.detail.sectionId);
            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },
    _onSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = _.find(this.instances, function (instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },
    register: function (type, constructor) {
        this.constructors[type] = constructor;
        $('[data-section-type=' + type + ']').each(function (index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});
velatheme.Slideshow = (function () {
    this.$slideshow = null;
    var classes = {
        wrapper: 'velaSlideshowWrapper',
        slideshow: 'slideshow',
        currentSlide: 'slick-current',
        video: 'velassVideo',
        videoBackground: 'velassVideoBackground',
        closeVideoBtn: 'btnssVideoControlClose',
        pauseButton: 'btnssPause',
        isPaused: 'is-paused'
    };

    function slideshow(el) {
        this.$slideshow = $(el);
        this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
        this.$pause = this.$wrapper.find('.' + classes.pauseButton);
        this.settings = {
            accessibility: true,
            arrows: true,
            dots: true,
            fade: true,
            pauseOnHover: true,
            draggable: true,
            touchThreshold: 20,
            autoplay: this.$slideshow.data('autoplay'),
            autoplaySpeed: this.$slideshow.data('speed')
        };
        this.$slideshow.on('beforeChange', beforeChange.bind(this));
        this.$slideshow.on('init', slideshowA11y.bind(this));
        this.$slideshow.slick(this.settings);
        this.$pause.on('click', this.togglePause.bind(this));
    }
    function slideshowA11y(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        var $wrapper = this.$wrapper;
        var autoplay = this.settings.autoplay;
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
        // When an element in the slider is focused
        // pause slideshow and set aria-live.
        $wrapper.on('focusin', function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.attr('aria-live', 'polite');
            if (autoplay) {
                $slider.slick('slickPause');
            }
        });
        //Resume autoplay
        $wrapper.on('focusout', function (evt) {
            if (!$wrapper.has(evt.target).length) {
                return;
            }
            $list.removeAttr('aria-live');
            if (autoplay) {
                // Manual check if the focused element was the video close button
                // to ensure autoplay does not resume when focus goes inside YouTube iframe
                if ($(evt.target).hasClass(classes.closeVideoBtn)) {
                    return;
                }
                $slider.slick('slickPlay');
            }
        });
        // Add arrow key support when focused
        if (obj.$dots) {
            obj.$dots.on('keydown', function (evt) {
                if (evt.which === 37) {
                    $slider.slick('slickPrev');
                }
                if (evt.which === 39) {
                    $slider.slick('slickNext');
                }
                // Update focus on newly selected tab
                if ((evt.which === 37) || (evt.which === 39)) {
                    obj.$dots.find('.slick-active button').focus();
                }
            });
        }
    };
    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide);
        var $nextSlide = $slider.find('.velassSlide[data-slick-index="' + nextSlide + '"]');
        if (isVideoInSlide($currentSlide)) {
            var $currentVideo = $currentSlide.find('.' + classes.video);
            var currentVideoId = $currentVideo.attr('id');
            velatheme.SlideshowVideo.pauseVideo(currentVideoId);
            $currentVideo.attr('tabindex', '-1');
        }
        if (isVideoInSlide($nextSlide)) {
            var $video = $nextSlide.find('.' + classes.video);
            var videoId = $video.attr('id');
            var isBackground = $video.hasClass(classes.videoBackground);
            if (isBackground) {
                velatheme.SlideshowVideo.playVideo(videoId);
            } else {
                $video.attr('tabindex', '0');
            }
        }
    }
    function isVideoInSlide($slide) {
        return $slide.find('.' + classes.video).length;
    }
    slideshow.prototype.togglePause = function () {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused);
            $(slideshowSelector).slick('slickPlay');
        } else {
            this.$pause.addClass(classes.isPaused);
            $(slideshowSelector).slick('slickPause');
        }
    };
    function getSlideshowId($el) {
        return '#velaSlideshows' + $el.data('id');
    }
    return slideshow;
})();
// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
    velatheme.SlideshowVideo.loadVideos();
}
velatheme.SlideshowVideo = (function () {
    var autoplayCheckComplete = false;
    var autoplayAvailable = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        playerVars: {
            // eslint-disable-next-line camelcase
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0,
            controls: 0,
            showinfo: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
            rel: 0
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerChange
        }
    };
    var classes = {
        playing: 'video-is-playing',
        paused: 'video-is-paused',
        loading: 'video-is-loading',
        loaded: 'video-is-loaded',
        slideshowWrapper: 'velaSlideshowWrapper',
        slide: 'velassSlide',
        slideBackgroundVideo: 'velassSlideBackgroundVideo',
        slideDots: 'slick-dots',
        videoChrome: 'velassVideo-chrome',
        videoBackground: 'velassVideoBackground',
        playVideoBtn: 'btnssVideoControlPlay',
        closeVideoBtn: 'btnssVideoControlClose',
        currentSlide: 'slick-current',
        slickClone: 'slick-cloned',
        supportsAutoplay: 'autoplay',
        supportsNoAutoplay: 'no-autoplay'
    };
    function init($video) {
        if (!$video.length) {
            return;
        }

        videos[$video.attr('id')] = {
            id: $video.attr('id'),
            videoId: $video.data('id'),
            type: $video.data('type'),
            status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
            videoSelector: $video.attr('id'),
            $parentSlide: $video.closest('.' + classes.slide),
            $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
            controls: $video.data('type') === 'background' ? 0 : 1,
            slideshow: $video.data('slideshow')
        };
        if (!youtubeLoaded) {
            // This code loads the IFrame Player API code asynchronously.
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }
    function customPlayVideo(playerId) {
        if (!playOnClickChecked && !playOnClick) {
            return;
        }
        if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
            privatePlayVideo(playerId);
        }
    }
    function pauseVideo(playerId) {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
            videoPlayers[playerId].pauseVideo();
        }
    }
    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                var args = $.extend({}, videoOptions, videos[key]);
                args.playerVars.controls = args.controls;
                videoPlayers[key] = new YT.Player(key, args);
            }
        }
        initEvents();
        youtubeLoaded = true;
    }
    function loadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
        initEvents();
    }
    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $slide = videos[id].$parentSlide;

        if (playOnClick) {
            // playOnClick means we are probably on mobile (no autoplay).
            // setAsPlaying will show the iframe, requiring another click
            // to play the video.
            setAsPlaying(videoData);
        } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
            // Play if autoplay is available or clicked to play
            $slide.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        }
        // Check for autoplay if not already done
        if (!autoplayCheckComplete) {
            autoplayCheckFunction(player, $slide);
        }
    }
    function setAutoplaySupport(supported) {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).addClass(supportClass);
        if (!supported) {
            playOnClick = true;
        }
        autoplayCheckComplete = true;
    }
    function autoplayCheckFunction(player, $slide) {
        // attempt to play video
        player.playVideo();
        autoplayTest(player)
            .then(function () {
                setAutoplaySupport(true);
            })
            .fail(function () {
                // No autoplay available (or took too long to start playing).
                // Show fallback image. Stop video for safety.
                setAutoplaySupport(false);
                player.stopVideo();
            })
            .always(function () {
                autoplayCheckComplete = true;
                $slide.removeClass(classes.loading);
            });
    }
    function autoplayTest(player) {
        var deferred = $.Deferred();
        var wait;
        var timeout;
        wait = setInterval(function () {
            if (player.getCurrentTime() <= 0) {
                return;
            }
            autoplayAvailable = true;
            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);
        timeout = setTimeout(function () {
            clearInterval(wait);
            deferred.reject();
        }, 4000); // subjective. test up to 8 times over 4 seconds
        return deferred;
    }
    function playOnClickCheck() {
        // Bail early for a few instances:
        // - small screen
        // - device sniff mobile browser
        if (playOnClickChecked) {
            return;
        }
        if ($(window).width() < 750) {
            playOnClick = true;
        } else if (window.mobileCheck()) {
            playOnClick = true;
        }
        if (playOnClick) {
            // No need to also do the autoplay check
            setAutoplaySupport(false);
        }
        playOnClickChecked = true;
    }
    // The API will call this function when each video player is ready
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality('hd1080');
        var videoData = getVideoOptions(evt);
        playOnClickCheck();
        // Prevent tabbing through YouTube player controls until visible
        $('#' + videoData.id).attr('tabindex', '-1');
        sizeBackgroundVideos();
        // Customize based on options from the video ID
        switch (videoData.type) {
            case 'background-chrome':
            case 'background':
                evt.target.mute();
                // Only play the video if it is in the active slide
                if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
                    privatePlayVideo(videoData.id);
                }
                break;
        }
        videoData.$parentSlide.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        switch (evt.data) {
            case 0: // ended
                setAsFinished(videoData);
                break;
            case 1: // playing
                setAsPlaying(videoData);
                break;
            case 2: // paused
                setAsPaused(videoData);
                break;
        }
    }
    function setAsFinished(videoData) {
        switch (videoData.type) {
            case 'background':
                videoPlayers[videoData.id].seekTo(0);
                break;
            case 'background-chrome':
                videoPlayers[videoData.id].seekTo(0);
                closeVideo(videoData.id);
                break;
            case 'chrome':
                closeVideo(videoData.id);
                break;
        }
    }
    function setAsPlaying(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        $slide.removeClass(classes.loading);
        // Do not change element visibility if it is a background video
        if (videoData.status === 'background') {
            return;
        }
        $('#' + videoData.id).attr('tabindex', '0');
        switch (videoData.type) {
            case 'chrome':
            case 'background-chrome':
                $slideshow
                    .removeClass(classes.paused)
                    .addClass(classes.playing);
                $slide
                    .removeClass(classes.paused)
                    .addClass(classes.playing);
                break;
        }
        // Update focus to the close button so we stay within the slide
        $slide.find('.' + classes.closeVideoBtn).focus();
    }
    function setAsPaused(videoData) {
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        if (videoData.type === 'background-chrome') {
            closeVideo(videoData.id);
            return;
        }
        // YT's events fire after our click event. This status flag ensures
        // we don't interact with a closed or background video.
        if (videoData.status !== 'closed' && videoData.type !== 'background') {
            $slideshow.addClass(classes.paused);
            $slide.addClass(classes.paused);
        }
        if (videoData.type === 'chrome' && videoData.status === 'closed') {
            $slideshow.removeClass(classes.paused);
            $slide.removeClass(classes.paused);
        }
        $slideshow.removeClass(classes.playing);
        $slide.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var $slideshow = videoData.$parentSlideshowWrapper;
        var $slide = videoData.$parentSlide;
        var classesToRemove = [classes.pause, classes.playing].join(' ');
        $('#' + videoData.id).attr('tabindex', '-1');
        videoData.status = 'closed';
        switch (videoData.type) {
            case 'background-chrome':
                videoPlayers[playerId].mute();
                setBackgroundVideo(playerId);
                break;
            case 'chrome':
                videoPlayers[playerId].stopVideo();
                setAsPaused(videoData); // in case the video is already paused
                break;
        }
        $slideshow.removeClass(classesToRemove);
        $slide.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
        return videos[evt.target.h.id];
    }
    function startVideoOnClick(playerId) {
        var videoData = videos[playerId];
        // add loading class to slide
        videoData.$parentSlide.addClass(classes.loading);
        videoData.status = 'open';
        switch (videoData.type) {
            case 'background-chrome':
                unsetBackgroundVideo(playerId, videoData);
                videoPlayers[playerId].unMute();
                privatePlayVideo(playerId, true);
                break;
            case 'chrome':
                privatePlayVideo(playerId, true);
                break;
        }
        // esc to close video player
        $(document).on('keydown.videoPlayer', function (evt) {
            if (evt.keyCode === 27) {
                closeVideo(playerId);
            }
        });
    }
    function sizeBackgroundVideos() {
        $('.' + classes.videoBackground).each(function (index, el) {
            sizeBackgroundVideo($(el));
        });
    }
    function sizeBackgroundVideo($player) {
        var $slide = $player.closest('.' + classes.slide);
        // Ignore cloned slides
        if ($slide.hasClass(classes.slickClone)) {
            return;
        }
        var slideWidth = $slide.width();
        var playerWidth = $player.width();
        var playerHeight = $player.height();
        // when screen aspect ratio differs from video, video must center and underlay one dimension
        if (slideWidth / videoOptions.ratio < playerHeight) {
            playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
            $player.width(playerWidth).height(playerHeight).css({
                left: (slideWidth - playerWidth) / 2,
                top: 0
            }); // player width is greater, offset left; reset top
        } else { // new video width < window width (gap to right)
            playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
            $player.width(slideWidth).height(playerHeight).css({
                left: 0,
                top: (playerHeight - playerHeight) / 2
            }); // player height is greater, offset top; reset left
        }
        $player
            .addClass(classes.loaded);
    }
    function unsetBackgroundVideo(playerId) {
        // Switch the background-chrome to a chrome-only player once played
        $('#' + playerId)
            .removeAttr('style')
            .removeClass(classes.videoBackground)
            .addClass(classes.videoChrome);
        videos[playerId].$parentSlideshowWrapper
            .removeClass(classes.slideBackgroundVideo)
            .addClass(classes.playing);
        videos[playerId].$parentSlide
            .removeClass(classes.slideBackgroundVideo)
            .addClass(classes.playing);
        videos[playerId].status = 'open';
    }
    function setBackgroundVideo(playerId) {
        // Switch back to background-chrome when closed
        var $player = $('#' + playerId)
            .addClass(classes.videoBackground)
            .removeClass(classes.videoChrome);
        videos[playerId].$parentSlide
            .addClass(classes.slideBackgroundVideo);
        videos[playerId].status = 'background';
        sizeBackgroundVideo($player);
    }
    function initEvents() {
        $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data('controls');
            startVideoOnClick(playerId);
        });
        $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function (evt) {
            var playerId = $(evt.currentTarget).data('controls');
            closeVideo(playerId);
        });
    }
    function removeEvents() {
        $(document).off('.videoPlayer');
        $(window).off('.videoPlayer');
    }
    return {
        init: init,
        loadVideos: loadVideos,
        loadVideo: loadVideo,
        playVideo: customPlayVideo,
        pauseVideo: pauseVideo,
        removeEvents: removeEvents
    };
})();
velatheme.slideshows = {};
velatheme.SlideshowSection = (function () {
    function SlideshowSection(container) {
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
        var slideshow = this.slideshow = '#velaSlideshows' + sectionId;
        $('.velassVideo', slideshow).each(function () {
            var $el = $(this);
            velatheme.SlideshowVideo.init($el);
            velatheme.SlideshowVideo.loadVideo($el.attr('id'));
        });
        velatheme.slideshows[slideshow] = new velatheme.Slideshow(slideshow);
    }
    return SlideshowSection;
})();
velatheme.SlideshowSection.prototype = _.assignIn({}, velatheme.SlideshowSection.prototype, {
    onUnload: function () {
        delete velatheme.slideshows[this.slideshow];
    },
    onBlockSelect: function (evt) {
        var $slideshow = $(this.slideshow);
        // Ignore the cloned version
        var $slide = $('.velassSlide' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },
    onBlockDeselect: function () {
        // Resume autoplay
        $(this.slideshow).slick('slickPlay');
    }
});

vela.dismissFlashBanner = function () {
    $('#flash-banner').on('closed.bs.alert', function () {
        $('#pageContainer').removeClass('has-flash-banner');
    })
}

$(document).ready(function () {
    $(vela.init);
    $('body').on('ajaxCart.afterCartLoad', function (evt, cart) {
        vela.RightDrawer.open();
    });
    
    var sections = new velatheme.Sections();
    sections.register('velaSlideshowSection', velatheme.SlideshowSection);
});
$(window).load(function () {
    $(vela.productImage);
    $(vela.loadingSite);
    $(window).resize(function () {
        vela.productImage();
        vela.owlOneCarousel();
    });
});function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var stickCart = function () {
  var win = $(window);
  var stickCart = $('.stick-cart-js');
  if (!stickCart) {
    return;
  }

  win.scroll(function (e) {
    if (win.scrollTop() > 80) {
      stickCart.addClass('stick-cart-js--show');
    } else {
      stickCart.removeClass('stick-cart-js--show');
    }
  });
};

$(window).load(function () {
  ajaxGetCart();
});

$(document).ready(function () {
  stickCart();
  $(document).on('click', '.formAddToCart .errorContainer', function (event) {
    removeErrors();
  });

  $(document).on('change keyup kaydown blur', '.formAddToCart .velaQtyNum', function () {
    removeErrors();
    var qty = $(this).val().replace(/[^0-9]/, '');
    $(this).prop('value', qty);
    var min = $(this).attr('min');
    var max = $(this).attr('max');
    if (parseInt(qty,10) < parseInt(min,10) && !($(this).hasClass("in-cart"))) {
      $(this).prop('value', min);
      //qty=min;
    } else if (parseInt(qty,10) > parseInt(max,10)) {
      $(this).prop('value', max);
    } else {
      $(this).prop('value', qty);
    }
  });
  //cart add

  $(document).on('click', '.formAddToCart .btnAddToCart', function (event) {
    event.preventDefault();
    const form = $(this).closest('.formAddToCart');
    const valueInputAttributes = form.find('.velaQtyNum');
    let id = form.find('input[name=product_id]').prop('value');
    let qty = valueInputAttributes.prop('value');
    let min = valueInputAttributes.attr('min');
    let max = valueInputAttributes.attr('max');
    //if undefined, product page loaded
    if (qty === undefined) {
        qty = $('.velaQtyNum').val();
    }
    if (id === undefined) {
        id = $('.velaQtyNum').attr('id').replace("updates_", "");
    }
    if (max === undefined) {
        max = $('.velaQtyNum').attr('max');
    }
    if (min === undefined) {
        min = $('.velaQtyNum').attr('min');
    }

    if (parseInt(qty,10) < parseInt(min,10) && !($(this).prev().find('input').hasClass("in-cart"))) {
      $(this).prev().find('.velaQtyNum').prop('value', min);
      qty = min;
    } else if (parseInt(qty,10) > parseInt(max,10)) {
      $(this).prev().find('.velaQtyNum').prop('value', max);
    } else {
      $(this).prev().find('.velaQtyNum').prop('value', qty);
    }
    ajaxAddToCart(form, qty, id, max);
    $(this).prev().find('.velaQtyNum').prop('value', 1);
  });

  $(document).on('click', '.formAddToCart .velaQtyAdjustPlus', function (event) {
    event.preventDefault();
    removeErrors();
    var qty = $(this).siblings('input').val();
    var min = $(this).siblings('input').attr('min');
    var max = $(this).siblings('input').attr('max');
    $(".formAddToCart").find(".cartError").remove();
    $(".formAddToCart").find('.btnAddToCart').prop('disabled', false);
    if (parseInt(qty,10) < parseInt(min,10)) {
      $(this).siblings('input').attr('value', min);
    } else if (parseInt(qty,10) > parseInt(max,10)) {
      $(this).siblings('input').attr('value', max);
    } else {
      $(this).siblings('input').attr('value', qty);
    }
  });


  $(document).on('click', '.formAddToCart .velaQtyAdjustMinus', function (event) {
    event.preventDefault();
    removeErrors();
    var qty = $(this).siblings('input').val();
    var min = $(this).siblings('input').attr('min');
    var max = $(this).siblings('input').attr('max');

    if (parseInt(qty,10) < parseInt(min,10) && !($(this).siblings('input').hasClass("in-cart"))) {
      $(this).siblings('input').prop('value', min);
    } else if (parseInt(qty,10) > parseInt(max,10)) {
      $(this).siblings('input').prop('value', max);
    } else {
      $(this).siblings('input').prop('value', qty);
    }
  });

  $(document).on('blur', '.cartForm .velaQtyNum', function () {
    var qty = $(this).val();
    var min = $(this).attr('min');
    var max = $(this).attr('max');

    if (parseInt(qty,10) < parseInt(min,10)) {
      $(this).val(min);
    } else if (parseInt(qty,10) > parseInt(max,10)) {
      $(this).val(max);
    } else {
      $(this).val(qty);
    }
  });

  $(document).on('click', '.cartForm .velaQtyAdjust', function () {
    var totalQuantity = 0;
    var qty = $(this).siblings('input').val();
    var min = $(this).siblings('input').attr('min');
    var max = $(this).siblings('input').attr('max');
    if ($('.cartForm').length > 0) {
      if (parseInt(qty,10) < parseInt(min,10)) {
        $(this).siblings('input').val(min)
      } else if (parseInt(qty,10) > parseInt(max,10)) {
        $(this).siblings('input').val(max)
      }
      $(".velaQtyNum").each(function () {
        if (parseInt($(this).val(),10) < parseInt($(this).attr('min'),10)) {
          totalQuantity = totalQuantity + parseInt($(this).attr('min'),10);
        } else {
          totalQuantity = totalQuantity + parseInt($(this).val(),10);
        }
      });
      $(".stick-cart__quantity").text(totalQuantity);
      $("#CartCount").text(totalQuantity);
    }
  });
});
var ajaxAddToCart = function (form, qty, id) {
    // The form parameter passed in to this function is not actually a form but rather the add to cart button
    showLoader(form);
    let formdata;
    if(window.FormData){
        formdata = new FormData(form[0]);
        formdata.append('quantity', qty);
        formdata.append('id', id);
    }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formdata ? formdata : form.serialize(),
    contentType : false,    // Optional. If the form tag with content type of enctype="multipart/form-data", this comes as a default.
    processData : false,    // Optional. If you want to send a DOMDocument, or other non-processed data.
    complete: function complete(data) {
      // Is added out of stock item to cart
      var responseData = $(JSON.parse(data.responseText));

      if (responseData.prop('status') == 422) {
        $(form).append("<div class=\"errorContainer\"><h3 class=\"cartError\">" + responseData.prop('message') + "</h3><p class=\"cartError\">" + responseData.prop('description') + "</p></div>");
        $(form).find('.btnAddToCart').prop('disabled', true);
        ajaxUpdateCartQuantity();
        hideLoader(form);
        return;
      }

      ajaxGetCart(true);
      hideLoader(form);
    }
  });
}

var ajaxUpdateCart = function (id, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: _defineProperty({}, id, qty)
    },
    complete: function complete(data) {
      ajaxUpdateCartQuantity();
    }
  });
}

var ajaxGetCart = function (showCart) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    complete: function complete(data) {
      let responseData = $(JSON.parse(data.responseText));

        if (showCart) {
            showSidebarCart(responseData);
        }

      for (let i = 0;
        (responseData.prop('items').length) > i; i++) {
          let id = responseData.prop('items')[i]['id'];
          let max = $('.formAddToCart #updates_' + id).attr("max");
          let qty = responseData.prop('items')[i]['quantity'];
          if (qty >= max) {
            ajaxUpdateCart(id, max);
          }
      };
    }
  });
  ajaxUpdateCartQuantity();
}

var ajaxUpdateCartQuantity = function () {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    complete: function complete(data) {
      const responseData = $(JSON.parse(data.responseText));
      let totalQuantity = 0;
      responseData.prop('items').map(item => {
        totalQuantity = item.price > 0 ? totalQuantity + 1 : totalQuantity;
      });

      $(".stick-cart__quantity").text(totalQuantity);
      $("#CartCount").text(totalQuantity);
      for (var i = 0;
        (responseData.prop('items').length) > i; i++) {
        let id = responseData.prop('items')[i]['id'];
        let qty = responseData.prop('items')[i]['quantity'];
        let max = $('#updates_' + id).attr("max");
        if (parseInt(qty,10) >= parseInt(max,10)) {
          qty = max;
          $('.formAddToCart #updates_' + id).parent().parent().find('.btnAddToCart').prop('disabled', true);
        }
        $('.formAddToCart #updates_' + id).parent().parent().find('.min-quantity-before-cart').css("display", "none");
        $('.formAddToCart #updates_' + id).parent().parent().find('.quantity-in-cart').css("display", "block");
        $('.formAddToCart #updates_' + id).parent().parent().find('.quantity-in-cart span').text(qty);
        $('.formAddToCart #updates_' + id).prop('value', 1).prop('min', 1);
        if (max !== undefined) {
          $('.proBoxInfo .min-quantity-before-cart').css("display", "none");
          $('.proBoxInfo .quantity-in-cart').css("display", "block");
          $('.proBoxInfo .quantity-in-cart span:not([class^="bull"])').text(qty);
        }
        const key = $('.cartForm #updates_' + id).data("key");
        $(`.cartForm input[data-key="${key}"] [type='text']`).prop("value", qty);
      }
    }
  });
}
var showLoader = function (form) {
  var $container = form;
  $container.append('<div class="custom-promo-loader" style="z-index:10;position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(255, 255, 255, 0.3)"><svg style="position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="60px" height="60px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><path fill="#1066af" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/></path></svg></div>');
};
var hideLoader = function () {
  $('.custom-promo-loader').remove();
};
var removeErrors = function () {
  $(".formAddToCart").find(".errorContainer").remove();
  $(".formAddToCart").find('.btnAddToCart').prop('disabled', false);
};

var showSidebarCart = function (cart) {
    $(document).trigger("cartChange", cart);
};!function(){window.mobileCheck=function(){var e=!1;return function(t){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}}()
